export enum EcoNewsletterControlName {
  Types = 'types',
  Subjects = 'subjects',
  Email = 'email'
}
